import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { ProfessionalProfileDto } from "@reactive-resume/dto";

import { fetchMyProfile, updateMyProfile } from "./api";

export const PROFILE_KEYS = {
  all: ["profile"] as const,
  me: () => [...PROFILE_KEYS.all, "me"] as const,
};

/** Profil utilisateur + profil professionnel (GET /profile/me). */
export const useMyProfile = () =>
  useQuery({
    queryKey: PROFILE_KEYS.me(),
    queryFn: fetchMyProfile,
  });

/** Mise à jour du profil professionnel (PATCH /profile/me — upsert). */
export const useUpdateMyProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto: Partial<ProfessionalProfileDto>) => updateMyProfile(dto),
    onSuccess: (updated) => {
      queryClient.setQueryData(PROFILE_KEYS.me(), updated);
    },
  });
};
